/* eslint-disable import/prefer-default-export */
const API = process.env.REACT_APP_API_URL;
const FILES_URL = `${API}/files/`;

export {
  API,
  FILES_URL,
};
